import type { CardProps } from "./Card.types.js";

// ============================================================
// Card Komponente — Image-basiert
// ============================================================

export function Card({
  card,
  imageUrl,
  backUrl,
  onClick,
  selected = false,
  disabled = false,
  className = "",
}: CardProps) {
  const handleClick = () => {
    if (!disabled && onClick) onClick(card);
  };

  const src = card.faceUp ? imageUrl : backUrl;
  const alt = card.faceUp
    ? `${card.rank} of ${card.suit}`
    : "Verdeckte Karte";

  const baseClasses = [
    "relative w-full block select-none",
    selected
      ? "ring-2 ring-offset-1 ring-yellow-400 shadow-lg shadow-yellow-400/40 rounded-md"
      : "",
    !disabled ? "cursor-pointer" : "cursor-default",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div
      className={baseClasses}
      onClick={handleClick}
      role={disabled ? "img" : "button"}
      aria-label={alt}
      tabIndex={disabled ? -1 : 0}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-auto block rounded-md pointer-events-none"
        draggable={false}
      />
    </div>
  );
}
